var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return (_vm.dimensions ?? []).length
    ? _c(
        "div",
        _vm._l(_vm.dimensions, function (d) {
          return d.id
            ? _c(
                "div",
                { staticClass: "flex flex_gap_5 align-items-center mb-1" },
                [
                  _c("img", { attrs: { src: "/assets/icons/dimensions.png" } }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(d.array_value.depth) +
                        "/" +
                        _vm._s(d.array_value.width) +
                        "/" +
                        _vm._s(d.array_value.height)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: "/assets/icons/weight.png" } }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(d.array_value.weight))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex-grow-1 flex justify-content-end" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-success btn-xs",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.addDimension()
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: { src: "/assets/icons/new_dimension.png" },
                          }),
                          _vm._v("\n        добавить\n      "),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e()
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }